export default __webpack_public_path__ + "69a9c917d8775edd9c6d2f1e5bdd0b80.svg";